// extracted by mini-css-extract-plugin
export default {"overlay":"qz-z","bodyOpen":"rz-z","content":"sz-z","header":"tz-z","close":"uz-z","closeNoHeading":"vz-z"};